import * as ACTION_TYPES from '../types';

let initialState = {
  pages: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_PAGES_REQUEST:
      return { ...state, loading:true };
    case ACTION_TYPES.GET_PAGES_SUCCESS:
      return { ...state, pages: action.data, loading: false };
    case ACTION_TYPES.GET_PAGES_FAILED:
      return { ...state, loading: false };
    case ACTION_TYPES.RESET_PAGES:
      return { ...state, pages: [] };
    default:
      return state;
  }
};
